import WhmcsApi from './WhmcsApi';
import Swal from 'sweetalert2';

export const fetchAddDomain = async (domain, regperiod) => {
    try {
      const whmcsApi = new WhmcsApi(); // Create instance of WhmcsApi
      const response = await whmcsApi.request('addDomain', {
        domain, regperiod
      }, 'POST', null);
      return response
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: error.message,
        icon: 'error',
        confirmButtonText: 'OK'
      });
      console.error('Failed to fetch fetchAddDomain:', error);
    }
  };

  export const fetchRemovedomain = async (domain) => {
    try {
      const whmcsApi = new WhmcsApi(); // Create instance of WhmcsApi
      const response = await whmcsApi.request('removeDomain', {
        domain
      }, 'POST', null);
      return response
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: error.message,
        icon: 'error',
        confirmButtonText: 'OK'
      });
      console.error('Failed to fetch removeDomain:', error);
    }
  };

  export const fetchClearCart = async () => {
    try {
      const whmcsApi = new WhmcsApi(); // Create instance of WhmcsApi
      const response = await whmcsApi.request('clearCartCount', {
      }, 'POST', null);
      return response
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: error.message,
        icon: 'error',
        confirmButtonText: 'OK'
      });
      console.error('Failed to fetch clearCartCount:', error);
    }
  };